
const mouse_dot = document.getElementById('mouse-dot');
const mouse_ring = document.getElementById('mouse-ring');
let mx = innerWidth / 2, my = innerHeight / 2;
let rx = mx, ry = my;
let lag = 0.2;
let pulseEl = null;

// mouse tracking
document.addEventListener('mousemove', e => {
  mx = e.clientX; my = e.clientY;
  mouse_dot.style.left = mx + 'px';
  mouse_dot.style.top = my + 'px';
});

// lag loop
(function loop() {
  rx += (mx - rx) * lag;
  ry += (my - ry) * lag;
  mouse_ring.style.left = rx + 'px';
  mouse_ring.style.top = ry + 'px';
  if (pulseEl) { pulseEl.style.left = rx + 'px'; pulseEl.style.top = ry + 'px'; }
  requestAnimationFrame(loop);
})();

// hover + pulse
const targets = 'a,button';

function spawnPulse() {
  if (pulseEl) return;
  pulseEl = document.createElement('div');
  pulseEl.className = 'mouse-ring-pulse';
  pulseEl.style.left = rx + 'px';
  pulseEl.style.top = ry + 'px';
  document.body.appendChild(pulseEl);
}
function destroyPulse() {
  if (pulseEl) { pulseEl.remove(); pulseEl = null; }
}

document.addEventListener('mouseover', e => {
  if (e.target.closest(targets)) {
    mouse_dot.classList.add('hover');
    mouse_ring.classList.add('hover');
    spawnPulse();
  }
});
document.addEventListener('mouseout', e => {
  if (e.target.closest(targets)) {
    mouse_dot.classList.remove('hover');
    mouse_ring.classList.remove('hover');
    destroyPulse();
  }
});

// click
document.addEventListener('mousedown', () => { mouse_dot.classList.add('click'); mouse_ring.classList.add('click'); });
document.addEventListener('mouseup', () => { mouse_dot.classList.remove('click'); mouse_ring.classList.remove('click'); });

// hide on leave
document.addEventListener('mouseleave', () => { mouse_dot.style.opacity = '0'; mouse_ring.style.opacity = '0'; });
document.addEventListener('mouseenter', () => { mouse_dot.style.opacity = '1'; mouse_ring.style.opacity = '1'; });
